import type { ThemeConfig } from "antd";

export const medSyncTheme: ThemeConfig = {
  token: {
    colorPrimary: "#E4002B",
    colorLink: "#E4002B",
    colorLinkHover: "rgba(228,0,43,0.8)",
    colorError: "#E4002B",
    colorSuccess: "#00E4B9",
    colorWarning: "#F9CA39",
    colorInfo: "#0A2947",

    colorText: "#3A3D42",
    colorTextSecondary: "#75787B",
    colorTextHeading: "#0A2947",
    colorTextDescription: "#75787B",

    colorBgBase: "#FFFFFF",
    colorBgContainer: "#FFFFFF",
    colorBgLayout: "#FFFFFF",
    colorBgElevated: "#FFFFFF",
    // Darker than antd's default (rgba(0,0,0,0.45)) — applies to every Modal AND
    // Drawer mask app-wide from this one token, so every dialog (SlideOver included)
    // dims the background more prominently behind it, not just a hand-picked few.
    colorBgMask: "rgba(0, 0, 0, 0.65)",

    colorBorder: "#DAD9D8",
    colorBorderSecondary: "#DAD9D8",

    borderRadius: 10,
    borderRadiusSM: 8,
    borderRadiusLG: 12,
    borderRadiusXS: 6,

    controlHeight: 32,
    controlHeightSM: 24,
    controlHeightLG: 40,

    fontFamily: "'Inter', system-ui, sans-serif",
    fontSizeHeading1: 32,
    fontSize: 14,

    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  },

  components: {
    Button: {
      controlHeight: 32,
      controlHeightSM: 24,
      controlHeightLG: 40,
      paddingInline: 15,
      paddingInlineSM: 7,
      borderRadius: 10,
      fontWeight: 500,
      primaryShadow: "none",
      defaultShadow: "none",
      colorPrimaryHover: "rgba(228,0,43,0.9)",
      defaultBorderColor: "#DAD9D8",
      defaultColor: "#3A3D42",
      defaultHoverColor: "#E4002B",
      defaultHoverBorderColor: "#E4002B",
      ghostBg: "transparent",
    },
    Input: {
      controlHeight: 36,
      borderRadius: 6,
      hoverBorderColor: "#E4002B",
      activeBorderColor: "#E4002B",
      activeShadow: "0 0 0 2px rgba(228,0,43,0.12)",
    },
    Card: {
      borderRadiusLG: 12,
      paddingLG: 16,
    },
    Tag: {
      borderRadiusSM: 4,
      lineHeight: 1.25,
    },
    Modal: {
      borderRadiusLG: 8,
      paddingContentHorizontal: 24,
    },
    Switch: {
      trackHeight: 22,
      trackMinWidth: 44,
      handleSize: 18,
      colorPrimary: "#E4002B",
    },
    Tooltip: {
      colorBgSpotlight: "#3A3D42",
    },
    // Solid brand red reads too heavy for a step indicator — use the same
    // 50%-opacity red convention already used app-wide (see index.css's
    // rgba(228,0,43,0.5) rules) instead of full-strength colorPrimary.
    Steps: {
      colorPrimary: "rgba(228,0,43,0.5)",
    },
  },
};
